import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPro = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 37 16"
    {...props}
  >
    <rect width={37} height={16} fill="url(#PRO_svg__a)" rx={3} />
    <path
      fill="#292A33"
      d="M8.547 4.281a.498.498 0 0 1 .89 0L10.47 6.36l2.281.329c.406.062.563.562.266.859l-1.641 1.61.39 2.265c.063.406-.374.719-.734.531L9 10.875l-2.047 1.078c-.36.188-.797-.125-.734-.531l.39-2.266-1.64-1.61c-.297-.296-.14-.796.265-.859l2.297-.328zM19.894 4.289q.693 0 1.221.286t.814.814q.297.517.297 1.199 0 .67-.297 1.188t-.847.803q-.54.275-1.254.275h-1.76q-.055 0-.055.055v2.959q0 .056-.044.099a.12.12 0 0 1-.088.033h-1.012a.16.16 0 0 1-.099-.033.16.16 0 0 1-.033-.099V4.421q0-.055.033-.088a.14.14 0 0 1 .099-.044zm-.187 3.531q.561 0 .902-.33t.341-.869q0-.55-.341-.891-.34-.34-.902-.341h-1.639q-.055 0-.055.055v2.321q0 .055.055.055zm6.135-1.507q.352 0 .616.143.088.044.066.165l-.187.99q-.011.132-.154.077a1.2 1.2 0 0 0-.385-.055q-.143 0-.22.011a1.13 1.13 0 0 0-.77.33q-.308.297-.308.781v3.113q0 .056-.044.099a.12.12 0 0 1-.088.033h-1.012a.16.16 0 0 1-.099-.033.16.16 0 0 1-.033-.099V6.511q0-.055.033-.088a.14.14 0 0 1 .099-.044h1.012q.055 0 .088.044.044.033.044.088v.495q0 .045.011.055.023 0 .044-.033.462-.715 1.287-.715m3.797 5.775q-.869 0-1.496-.44-.615-.44-.869-1.221a4.2 4.2 0 0 1-.187-1.254q0-.704.176-1.254a2.26 2.26 0 0 1 .88-1.199q.627-.429 1.507-.429.837 0 1.441.429.616.429.87 1.188.197.528.197 1.254 0 .693-.187 1.254-.252.78-.869 1.232-.615.44-1.463.44m0-1.1q.408 0 .693-.231.297-.23.43-.649.11-.363.11-.924 0-.594-.11-.924a1.17 1.17 0 0 0-.419-.638 1.15 1.15 0 0 0-.726-.231q-.407 0-.704.231-.296.22-.429.638-.11.385-.11.924 0 .54.11.924.121.418.418.649.308.231.737.231"
    />
    <defs>
      <linearGradient
        id="PRO_svg__a"
        x1={0}
        x2={37}
        y1={0}
        y2={16}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFDBA6" />
        <stop offset={1} stopColor="#E1AA56" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgPro;
